module.exports = __webpack_public_path__ + "img/product-shot_06_loading.6c98e91e.jpg";